<div class="customer-agreement-capture">
  <div class="customer-agreement-capture__title"
      [innerHTML]="getTranslationKey('title') | translate | safeHtml">
  </div>

  <div class="customer-agreement-capture__camera-wrapper">
    <div class="customer-agreement-capture__camera-wrapper__frame-top">
      <img src="./assets/images/camera-frame-top.png">
    </div>
    <app-camera #camera
                (imageCapture)="onImageCapture($event)"
                (cameraInit)="onCameraInit()"
                class="customer-agreement-capture__camera-wrapper__camera">
    </app-camera>

    <div class="customer-agreement-capture__camera-wrapper__frame-bottom">
      <img src="./assets/images/camera-frame-bottom.png">
    </div>
  </div>

  <div class="customer-agreement-capture__buttons">
    <button class="btn btn--secondary btn--big"
            (click)="capture()">
      {{ getTranslationKey('capture') | translate }}
    </button>
    <button class="btn btn--outline"
            (click)="cancelCapture()">
      {{ getTranslationKey('cancel') | translate }}
    </button>
  </div>
</div>
